import { Button } from "@heroui/react";
import { useNavigate } from "react-router-dom";
import { LuMoveLeft, LuShieldAlert } from "react-icons/lu";

const Unauthorized = () => {
    const navigate = useNavigate();

    return (
        <div className="flex h-[80vh] flex-col items-center justify-center text-center">
            {/* Ambient Background Glow (Red for Alert) */}
            <div className="absolute top-1/2 left-1/2 -z-10 h-125 w-125 -translate-x-1/2 -translate-y-1/2 rounded-full bg-gradient-to-tr from-red-500/20 to-orange-500/20 opacity-50 blur-[100px] dark:from-red-500/10 dark:to-orange-500/10" />

            <div className="mb-8 flex items-center justify-center rounded-full bg-red-100 p-8 dark:bg-red-900/20">
                <LuShieldAlert className="h-24 w-24 text-red-500 dark:text-red-400" />
            </div>

            <h1 className="text-4xl font-bold tracking-tight text-zinc-800 md:text-5xl dark:text-zinc-100">
                Access Denied
            </h1>

            <p className="mt-4 max-w-md text-zinc-500 dark:text-zinc-400">
                You do not have the necessary permissions to view this page.
                Please contact your administrator if you believe this is an
                error.
            </p>

            <div className="pt-8">
                <Button
                    color="danger"
                    variant="flat"
                    startContent={<LuMoveLeft />}
                    onPress={() => navigate("/")}
                    className="font-semibold"
                >
                    Back to Dashboard
                </Button>
            </div>
        </div>
    );
};

export default Unauthorized;
